import { useState } from "react";
import { ChevronDown } from "lucide-react";

const MobileServicesGroup = ({
  label,
  serviceItems,
  onServiceClick,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex flex-col gap-3">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="mobile-nav-services"
        className="font-serif text-xl flex items-center justify-between"
        style={{ color: "var(--green-800)" }}
      >
        {label}
        <ChevronDown
          size={18}
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0)",
            transition: "transform var(--dur) var(--ease)",
            color: "var(--gold-500)",
          }}
        />
      </button>
      {open && (
        <ul
          className="flex flex-col gap-3 pl-4"
          style={{ borderLeft: "1px solid var(--border)" }}
          data-testid="mobile-services-submenu"
        >
          {serviceItems.map((s) => (
            <li key={s.key}>
              <a
                href={`#services-${s.key}`}
                data-testid={`mobile-submenu-${s.key}`}
                onClick={(e) => onServiceClick(s.key, e)}
                className="text-base"
                style={{ color: "var(--ink)" }}
              >
                {s.label}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const MobileLangSwitch = ({ lang, navigateLang }) => (
  <div className="flex items-center gap-4 pt-2">
    <button
      type="button"
      onClick={() => navigateLang("en")}
      data-testid="mobile-lang-en"
      className={`lang-pill ${lang === "en" ? "active" : ""}`}
    >
      EN
    </button>
    <span style={{ color: "var(--grey-200)" }}>/</span>
    <button
      type="button"
      onClick={() => navigateLang("uk")}
      data-testid="mobile-lang-uk"
      className={`lang-pill ${lang === "uk" ? "active" : ""}`}
    >
      UA
    </button>
  </div>
);

export const MobileMenu = ({
  t,
  lang,
  links,
  serviceItems,
  navigateLang,
  onServiceClick,
  onClose,
}) => (
  <div
    data-testid="mobile-menu"
    className="md:hidden"
    style={{
      background: "var(--white)",
      borderTop: "1px solid var(--border)",
    }}
  >
    <div className="px-6 py-8 flex flex-col gap-6">
      {links.map((l) =>
        l.key === "services" ? (
          <MobileServicesGroup
            key={l.href}
            label={l.label}
            serviceItems={serviceItems}
            onServiceClick={onServiceClick}
          />
        ) : (
          <a
            key={l.href}
            href={l.href}
            onClick={onClose}
            className="font-serif text-xl"
            style={{ color: "var(--green-800)" }}
          >
            {l.label}
          </a>
        )
      )}
      <MobileLangSwitch lang={lang} navigateLang={navigateLang} />
      <a
        href="#contact"
        onClick={onClose}
        className="btn btn-gold w-fit"
      >
        {t.nav.cta}
      </a>
    </div>
  </div>
);
